import MathUtil from "./mathUtils";

export function IEVersion () {
  const userAgent = window.navigator.userAgent; // 取得浏览器的userAgent字符串
  const isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; // 判断是否IE<11浏览器
  const isEdge = userAgent.indexOf("Edge") > -1 && !isIE; // 判断是否IE的Edge浏览器
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
  if (isIE) {
    // eslint-disable-next-line prefer-regex-literals
    const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    const fIEVersion = parseFloat(RegExp.$1);
    if (fIEVersion === 7) {
      return 7;
    } else if (fIEVersion === 8) {
      return 8;
    } else if (fIEVersion === 9) {
      return 9;
    } else if (fIEVersion === 10) {
      return 10;
    } else {
      return 6;// IE版本<=7
    }
  } else if (isEdge) {
    return 12;// edge
  } else if (isIE11) {
    return 11; // IE11
  } else {
    return -1;// 不是ie浏览器
  }
}

export function isString (value:any) {
  return typeof value === 'string'
}
export const formatUtils = {
/**
 * 每三位数字用逗号分隔
 * @param num 实际数值(number类型)（支持小于0的值）
 * @param digits 小数位位数，默认值：2，即保留两位小数（值范围：0~20），或者保留小数位范围[最小小数位，最大小数位]
 * @param sp 每隔几位数进行逗号分隔，默认值：3，即千分位逗号分隔
 * @param defaultValue 当值不存在的情况下显示的默认值，默认为空字符串
 * @param zeroFilling 当小数值不够保留位数时，是否自动补0，默认true
 * @returns {*}
 */
  formatNumber (num:any, digits:number|number[], sp:number, zeroFilling?:boolean) {
    if (isNaN(num) || num === '' || num === undefined || num === null) {
      // eslint-disable-next-line eqeqeq
      if (arguments.length == 4) return arguments[3];
      return '';
    }
    if (sp == null) sp = 3;
    if (!(digits instanceof Array)) {
      digits = (digits !== undefined && digits !== null && digits >= 0 && digits <= 20) ? digits : 2;
    }
    num = MathUtil.scienceNum(num);// 处理e+、e-情况
    num = parseFloat((num + "").replace(/[^\d.-]/g, ""));
    let flag = false;// 是否为负数
    if (num < 0) {
      flag = true;
      num = Math.abs(num);
    }
    if (digits instanceof Array) {
      const temp = num.toString().split(".")[1];
      const minDigits = digits[0]; const maxDigits = digits[1];
      if (typeof temp === "undefined" || temp.length <= minDigits) {
        num = num.toFixed(minDigits) + "";
      } else {
        num = num.toFixed(maxDigits) + "";
      }
    } else {
      num = num.toFixed(digits) + "";
    }
    zeroFilling = zeroFilling === undefined || zeroFilling === null ? true : zeroFilling;
    if (!zeroFilling) num = parseFloat(num) + "";
    let tem = num.split(".");// 按小数点分离
    let l = tem[0].split("").reverse();// 左侧数字
    let r = tem[1] && tem[1].length >= 1 ? tem[1] : "";// 右侧数字
    let scienceNum;
    // eslint-disable-next-line eqeqeq
    if (digits == 0) { // 去除小数位
      scienceNum = (flag ? "-" : "") + l.reverse().join("");
    } else { // 补充小数位
      scienceNum = (flag ? "-" : "") + l.reverse().join("") + "." + r;
      // eslint-disable-next-line eqeqeq
      if (!zeroFilling && r.length == 0) { // 非自动补零模式下，去除多余小数点
        scienceNum = scienceNum.split(".")[0];
      }
    }
    // 修正"-0.00"显示为"0.00"
    if (Number(scienceNum) === 0 && scienceNum.substring(0, 1) === '-') scienceNum = scienceNum.substring(1, scienceNum.length);
    let result = MathUtil.scienceNum(scienceNum);// 处理e+、e-情况
    // 处理千分位逗号
    if (sp > 0) {
      result = result.substring(0, 1) === '-' ? result.substring(1, result.length) : result;// 忽略负号
      tem = result.split(".");
      l = tem[0].split("").reverse();
      r = tem[1] && tem[1].length >= 1 ? tem[1] : "";
      let leftNum = "";
      for (let i = 0; i < l.length; i++) {
        // eslint-disable-next-line eqeqeq
        leftNum += l[i] + ((i + 1) % sp == 0 && (i + 1) != l.length ? "," : "");
      }
      result = (flag ? "-" : "") + leftNum.split("").reverse().join("") + "." + r;// 恢复负号
      // eslint-disable-next-line eqeqeq
      if (digits == 0 || (!zeroFilling && r.length == 0)) { // 非自动补零模式下，去除多余小数点
        result = result.split(".")[0];
      }
    }
    return result;
  },
  /**
   * 格式化金额
   * @param money
   * @returns
   */
  formatMoney (money:any) {
    return this.formatNumber(money, 2, 3);
  },
  /**
   * 格式化日期
   * @param date
   * @param format
   * @returns
   */
  formatDate (date:any, format:string) {
    if (typeof date === 'number') {
      date = new Date(date)
    }
    if (date === undefined || date === null || !(date instanceof Date)) {
      if (IEVersion() !== -1) { return isString(date) ? date.replace(/-/g, '/') : date; } else { return date; }
    }
    const o:any = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "(H|h)+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    };
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        // eslint-disable-next-line eqeqeq
        format = format.replace(RegExp.$1, RegExp.$1.length == 1
          ? o[k]
          : ("00" + o[k])
            .substr(("" + o[k]).length));
      }
    }
    if (IEVersion() !== -1) {
      format = isString(format) ? format.replace(/-/g, '/') : format;
    }
    return format;
  }
};
export default formatUtils;
